/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import { hmsAPI } from '@/api'

export const getEngineInfo = () => hmsAPI.get('ml-service/info').then(({ data }) => data)
export const getEngineStatus = () => hmsAPI.get('ml-service/status').then(({ data }) => data)
export const restartEngine = () => hmsAPI.post('ml-service/restart').then(({ data }) => data)
export const startEngine = () => hmsAPI.post('ml-service/start').then(({ data }) => data)
export const stopEngine = () => hmsAPI.post('ml-service/stop').then(({ data }) => data)
